<template>
  <div
    class="external-bidder-chip h9-text d-flex align-center justify-center main__green rounded-xl px-2 py-1 "
    data-qa="external-bidder">
    {{ $t('Tenders.External') }}
  </div>
</template>

<script>
export default {
  name: 'externalParticipantChip',
}
</script>
<style lang="scss" scoped>
.external-bidder-chip {
  width: fit-content;
}
</style>
